import TYPOGRAPHY_FLAT from '@styles/fonts/fontsizes/typography-flat';
import { deviceTypes } from '@styles/mediaQueries';
import { typeCSS } from '@utils/TypeCSS.styles';
import styled from 'styled-components';

interface IContainer {
  minLeft: number;
  maxLeft: number;
}

export const Container = styled.div<IContainer>`
  --sidebar-width: ${({ minLeft }) => minLeft}px;
  --sidebar-expanded-width: ${({ maxLeft }) => maxLeft}px;

  width: var(--offset-left);
  height: 100%;
  /* position: relative; */
  display: flex;
  align-items: center;
  background-color: #fff;
  box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.161);
  & {
    transition: width, var(--transition-duration) var(--transition-fn);
  }

  &[data-open='true'] {
    --offset-left: var(--sidebar-width-expanded);
  }
  &[data-open='false'] {
    --offset-left: var(--sidebar-width-closed);
  }
  &[data-open='true'][data-tab='accounts'] {
    --offset-left: min(360px, 80vw);
  }
`;

export const Bar = styled.div`
  width: 100%;
  height: 100%;
  padding: 19px 0;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  row-gap: 32px;
  overflow: hidden;
`;
Bar.displayName = 'Bar';
export const Toggle = styled.div`
  position: absolute;
  right: -12px;
  background: #fff;
  cursor: pointer;
  height: 24px;
  width: 24px;
  border-radius: 12px;
  box-shadow: 0px 3px 6px #00000029;
  display: flex;
  align-items: center;
  justify-content: center;
  /* z-index: 3; */
`;

interface IIcon {
  width: number;
}

export const Icon = styled.div`
  width: var(--sidebar-width);
  min-width: var(--sidebar-width);
  display: flex;
  flex-direction: column;
  align-items: center;
`;
export const StyledImg = styled.img<IIcon>`
  min-width: ${({ width }) => width / 2.5}px;
  width: ${({ width }) => width / 2.5}px;
`;
export const Item = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;

  padding: 9px 0;
`;
Item.displayName = 'Item';

export const Indicator = styled.div`
  height: 40px;
  width: 3px;
  border-radius: 2px;
  background: transparent;
  position: absolute;
  left: 2px;
  &[data-active='true'] {
    background-color: #1371fe;
  }
`;

export const Label = styled.div`
  color: var(--beam-color-neutral-n700);
  ${typeCSS(TYPOGRAPHY_FLAT.p200)}
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const Signout = styled.div`
  color: #1371fe;
  font-size: 13px;
  height: auto;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: pointer;
`;

export const Top = styled.div`
  display: flex;

  &[data-open='true'] {
    padding: 0 12px;
  }
`;

export const Mid = styled.div`
  /* z-index: 2; */
  display: flex;
  flex-direction: column;
  /* row-gap: 24px */
  row-gap: 27px;
`;

export const Bottom = styled.div`
  /* z-index: 2; */
  display: flex;
  flex-direction: column;
  /* row-gap: 8px */
  row-gap: 27px;

  [data-device='${deviceTypes.mobile}'] & {
    flex-grow: 1;
    justify-content: end;
  }
`;

export const Logo = styled.div`
  width: 100%;
  display: flex;
  transition: margin var(--transition-duration) var(--transition-fn);

  align-items: center;

  &[data-open='false'] {
    justify-content: center;
  }
  margin-top: 0;
`;
